import { Close } from '@mui/icons-material';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';
import { ArchiveIcon } from '../../../../vectors/index';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';
import { useUpdateJobPosting } from '@features/jobPostings/hooks/useUpdateJobPosting';
import { useUpdateTemplateJobPosting } from '@features/enterprise/hooks/useUpdateTemplateJobPosting';

type ArchivePositionModalProps = {
  isOpen: boolean;
  unArchive: boolean;
  templateId?: number;
  handleClose: () => void;
  jobPostingId: number;
};

const ArchivePositionModal: FC<ArchivePositionModalProps> = ({
  isOpen,
  unArchive,
  templateId,
  handleClose,
  jobPostingId,
}) => {
  if (!jobPostingId) {
    return null;
  }
  const [errorText, setErrorText] = useState('');
  const { updateJobPosting, isUpdatingJobPosting } = useUpdateJobPosting({
    refetch: true,
    setErrorText,
  });

  const {
    updateJobPosting: updateEnterpriseJob,
    isUpdatingJobPosting: isUpdatingEnterpriseJob,
  } = useUpdateTemplateJobPosting({ setErrorText });

  const handleArchive = () => {
    const options = {
      onSuccess: (data: { status: number }) => {
        if (data.status === 200) {
          toast.success('Job Archived successfully');
          handleClose();
        }
      },
    };
    if (templateId){
      updateEnterpriseJob({ id: jobPostingId as number, status: 4, template_id: templateId })
    }else{
      updateJobPosting({ id: jobPostingId, status: unArchive ? 2 : 4 }, options);
    }
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
        <br />
        <ArchiveIcon />
        <br />
        <Typography variant="h3" sx={{ p: 3 }}>
          Are you sure you want to {unArchive ? 'unarchive' : 'archive'} this job?
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {!unArchive && (
          <Typography textAlign='center' variant="h6" sx={{ pb: 5 }}>
            All active applications will also be archived
          </Typography>
        )}
        {errorText && (
          <Alert sx={{ margin: 3 }} severity="error">
            {errorText}
          </Alert>
        )}
        <Stack spacing={3}>
          <LoadingButton
            loading={isUpdatingJobPosting || isUpdatingEnterpriseJob}
            variant="contained"
            color="dark"
            onClick={handleArchive}
          >
            {unArchive ? 'Unarchive' : 'Archive'}
          </LoadingButton>
          <Button
            variant="outlined"
            onClick={handleClose}
            disabled={isUpdatingJobPosting || isUpdatingEnterpriseJob}
            startIcon={<CloseIcon />}
          >
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ArchivePositionModal;
